const styles = ({ COLORS }) => ({
  back: {
    display: 'flex',
    padding: '18px 0 18px 18px',
    alignItems: 'center',
    flexDirection: 'row',
    textDecoration: 'none',
    color: COLORS.BLUE.NORMAL
  }
})

export default styles
